<!-- PAGE HEADER -->

<div class="page-header">
    <h2>Voucher Setup</h2>
</div>
<ngx-spinner bdColor="rgba(0,0,0,0.6)" size="medium" color="#ffffff" type="ball-spin-clockwise" [fullScreen]="true">
</ngx-spinner>

<!-- FORM CARD -->
<div class="container pt-24">
    <p-stepper [(value)]="activeStep" [linear]="false">

        <!-- Step Header -->
        <p-step-list>
            <p-step [value]="1" (click)="onStepClick(1)" [ngClass]="getStepClass(1)"
                [class.submitted-lock]="isStepLockedAfterSubmit(1)">
            </p-step>

            <p-step [value]="2" (click)="onStepClick(2)" [ngClass]="getStepClass(2)"
                [class.disabled-step]="!canNavigateToStep(2)" [class.submitted-lock]="isStepLockedAfterSubmit(2)">
            </p-step>

            <p-step [value]="3" (click)="onStepClick(3)" [ngClass]="getStepClass(3)"
                [class.disabled-step]="!canNavigateToStep(3)" [class.submitted-lock]="isStepLockedAfterSubmit(3)">
            </p-step>

            <p-step [value]="4" (click)="onStepClick(4)" [ngClass]="getStepClass(4)"
                [class.disabled-step]="!canNavigateToStep(4)" [class.submitted-lock]="isStepLockedAfterSubmit(4)">
            </p-step>

            <!-- <p-step *ngIf="true" [value]="5" (click)="onStepClick(5)" [ngClass]="getStepClass(5)"
                [class.disabled-step]="!canNavigateToStep(5)" [class.submitted-lock]="isStepLockedAfterSubmit(5)">
            </p-step> -->

            <p-step [value]="5" (click)="onStepClick(5)"
                [ngClass]="getStepClass(5)"
                [class.disabled-step]="!canNavigateToStep(5)"
                [class.submitted-lock]="isStepLockedAfterSubmit(5)">
            </p-step>

        </p-step-list>

        <!-- Step Content -->
        <p-step-panels>
            <p-step-panel [value]="1">
                <ng-template pTemplate="content">
                    <form [formGroup]="step1Group">
                        <h2 class="step-title">Voucher Vaccine Selection</h2>

                        <p class="instruction">
                            Select one or more of the vaccines below to be included on your employee's flu and/or
                            routine voucher.
                        </p>

                        <div class="filter">
                            <label>Filter: </label>
                            <select #categorySelect (change)="onCategoryChange(categorySelect.value)">
                                <option value="">All Vaccines</option>
                                <option *ngFor="let category of categoryList" [value]="category.categoryCode">
                                    {{ category.categoryName }}
                                </option>
                            </select>
                        </div>
                        <div class="vaccine-list">
                            <div *ngFor="let item of filteredVaccineList; let i = index" class="accordion-card">

                                <div class="accordion-header">
                                    <div class="header-top">
                                        <input type="checkbox" [checked]="isSelected(item)"
                                            (change)="onCheckboxChange($event, item)" [value]="item" />
                                        <label>
                                        <strong>{{ item.vaccineName + ' ' + item.vaccineNameShort }}</strong>
                                        <span *ngIf="w9Approved || item.displayPrice" class="price">${{ item.vaccinePrice | number:'1.2-2' }}</span>
                                        <a [routerLink]="'/w9-business-verification'" *ngIf="!(w9Approved || item.displayPrice)" class="price-note">Complete business verification to unlock pricing</a>
                                        </label>
                                        <div class="info-icon" (click)="openDialog(item)">i</div>
                                    </div>
                                    <p class="description">
                                        {{item.vaccineTypeDescription}}
                                    </p>
                                </div>

                                <!-- <div class="accordion-body" *ngIf="openIndexes.includes(i)">

                                    <div class="option-row" *ngFor="let item of group.items">
                                        <input [style.visibility]="item.isSelectable ? 'visible' : 'hidden'" type="checkbox" [checked]="isSelected(item)"
                                            (change)="onCheckboxChange($event, item)" [value]="item" />
                                        <label>
                                            <strong>{{item.vaccineName + (item.isSelectable ? ' ' + item.vaccineNameShort : '') }}</strong>
                                            <span  [style.visibility]="item.isSelectable ? 'visible' : 'hidden'" class="price">${{ item.vaccinePrice | number:'1.2-2' }}</span>
                                            <div *ngIf="item.vaccineDescription != ''" class="sub-text">{{item.vaccineDescription}}</div>
                                        </label>
                                        <div [style.visibility]="item.isSelectable ? 'visible' : 'hidden'" class="info-icon" (click)="openDialog(item)">i</div>
                                    </div>
                                </div> -->
                            </div>

                            <p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [draggable]="false"
                                [resizable]="false" [dismissableMask]="false" styleClass="vaccine-dialog">
                                <ng-template pTemplate="header">
                                    {{dialogTitle}}
                                </ng-template>
                                <div class="dialog-content">

                                    <p class="highlight">
                                        <strong>Why the vaccine is needed:</strong>
                                        {{dialogBodyText1}}
                                    </p>

                                    <p class="highlight" *ngIf="dialogBodyText2 !== ''">
                                        <strong>Why people need it:</strong>
                                        {{dialogBodyText2}}
                                    </p>

                                    <div class="dialog-actions" *ngIf="cdcLinks.length === 0">
                                        <a [href]="cdcLink" target="_blank" pButton class="cdc-btn"
                                            label="View CDC guidance"></a>
                                    </div>

                                    <div *ngIf="cdcLinks.length > 0">
                                         <strong class="cdc-header">View CDC guidance:</strong>
  <div class="cdcLink" *ngFor="let link of cdcLinks">
    <a [href]="link.cdclink" target="_blank">
      {{ link.cdcName }}
    </a>
  </div>
</div>
                                    <div class="dialog-close">
                                        <button pButton label="Close" class="close-btn"
                                            (click)="closeDialog()"></button>
                                    </div>

                                </div>
                            </p-dialog>
                        </div>
                        <div class="form-actions">
                            <button type="button" (click)="cancel()">Cancel</button>
                            <button type="button" (click)="nextStep('step1', 1)" pStepperNext>Next</button>
                        </div>

                    </form>
                </ng-template>
            </p-step-panel>

            <p-step-panel [value]="2">
                <ng-template pTemplate="content">
                    <form [formGroup]="step2Group">
                        <h2 class="step-title">Voucher Information</h2>
                        <div>
                            <div class="step-note">
                                Enter your company or organization name as you would like it to appear on the voucher
                                along with the voucher expiration date.
                            </div>
                            <div>
                                <div class="form-grid">
                                    <div class="field">
                                        <label><span>* </span>Company or Organization Name</label>
                                        <input formControlName="programName" maxlength="100" type="text" />
                                        <div class="error-message"
                                            *ngIf="step2Group | invalidChars:'programName':ValidationPatterns.ALLOWED_BUSINESS_CHARS as invalidChars">
                                            Invalid chars: {{ invalidChars }}
                                        </div>
                                    </div>

                                    <div class="field" *ngIf="isFluVaccine">
                                        <label><span>* </span>Flu Voucher Exp</label>
                                        <p-datepicker [minDate]="fluExpiryMinDate" [maxDate]="fluExpiryMaxDate"
                                            formControlName="fluVoucherExpireDate" showIcon="false"
                                            styleClass="w-full"></p-datepicker>
                                    </div>

                                    <div class="field" *ngIf="isRoutineVaccine">
                                        <label><span>* </span>Routine Voucher Exp</label>
                                        <p-datepicker [minDate]="routineExpiryMinDate" [maxDate]="routineExpiryMaxDate"
                                            formControlName="routineVoucherExpireDate" showIcon="false"
                                            styleClass="w-full"></p-datepicker>
                                    </div>
                                </div>
                                <div class="required-note">
                                    <span>* </span> Required
                                </div>
                                <div class="row center-box">
                                    <div></div>
                                    <div><img src="assets/company_name_exp_placement.jpg" class="w-full"></div>
                                    <div></div>
                                </div>
                            </div>
                            <!-- REQUIRED NOTE -->



                        </div>
                        <div class="form-actions">
                            <button type="button" (click)="previousStep(2)" pStepperPrev>Back</button>
                            <button type="button" (click)="cancel()">Cancel</button>
                            <button type="button" (click)="nextStep('step2', 2)" pStepperNext>Next</button>
                        </div>
                    </form>
                </ng-template>
            </p-step-panel>

            <p-step-panel [value]="3">
                <ng-template pTemplate="content">
                    <h2 class="step-title">Invoice & Legal Information</h2>
                    <form [formGroup]="step3Group">
                        <div>
                            <div class="step-note">
                                Enter the information below in which you would like to be contacted regarding your
                                invoice for redeemed vouchers and legal notifications.
                            </div>
                            <!-- ================= INVOICE SECTION ================= -->
                            <h3 class="step-subtitle">Invoice Information</h3>

                            <div>

                                <div class="required-note">
                                    <input type="checkbox" formControlName="sameAsBusiness"
                                        (change)="toggleAddressSync()" />
                                    Invoice information is the same as the business/organization account information
                                </div>

                                <div class="row business-row">
                                    <div class="field">
                                        <label><span>* </span>Business/Organization</label>
                                        <input formControlName="businessName" maxlength="100" type="text" />
                                        <div class="error-message"
                                            *ngIf="step3Group | invalidChars:'businessName':ValidationPatterns.ALLOWED_BUSINESS_CHARS as invalidChars">
                                            Invalid chars: {{ invalidChars }}
                                        </div>
                                    </div>

                                    <div class="field" [ngClass]="displayFieldCss('step3.taxExempt')">
                                        <label><span>* </span>Is your business/organization tax exempt?</label>
                                        <select formControlName="taxExempt">
                                            <option value="">Select</option>
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </div>
                                    <div class="field"
                                        [ngClass]="displayFieldCss('step3.employerIdentificationNumber')">
                                        <label><span>* </span>Employer Identification Number (EIN)</label>
                                        <input type="text" formControlName="employerIdentificationNumber" maxlength="10"
                                            inputmode="numeric" placeholder="XX-XXXXXXX" mask="00-0000000"
                                            [validation]="true" [dropSpecialCharacters]="true">
                                    </div>
                                </div>

                                <div class="row name-job-row">
                                    <div class="field">
                                        <label><span>* </span>First Name</label>
                                        <input formControlName="firstName" maxlength="100" />
                                        <div class="error-message"
                                            *ngIf="step3Group | invalidChars:'firstName':ValidationPatterns.ALLOWED_NAME_CHARS as invalidChars">
                                            Invalid chars: {{ invalidChars }}
                                        </div>
                                    </div>

                                    <div class="field">
                                        <label><span>* </span>Last Name</label>
                                        <input formControlName="lastName" maxlength="100" />
                                        <div class="error-message"
                                            *ngIf="step3Group | invalidChars:'lastName':ValidationPatterns.ALLOWED_NAME_CHARS as invalidChars">
                                            Invalid chars: {{ invalidChars }}
                                        </div>
                                    </div>

                                    <div class="field">
                                        <label>Phone <span>*</span></label>
                                        <input type="text" formControlName="phone" mask="(000) 000-0000"
                                            [dropSpecialCharacters]="true" placeholder="(XXX) XXX-XXXX" />
                                    </div>

                                    <div class="field">
                                        <label>Fax</label>
                                        <input type="text" formControlName="fax" mask="(000) 000-0000"
                                            [dropSpecialCharacters]="true" placeholder="(XXX) XXX-XXXX" />
                                    </div>

                                    <div class="field">
                                        <label><span>* </span>Email</label>
                                        <input type="email" formControlName="email" maxlength="100"
                                            pattern="^[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]@[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$" />
                                        <div class="error-message"
                                            *ngIf="step3Group | invalidChars:'email':ValidationPatterns.ALLOWED_EMAIL_CHARS as invalidChars">
                                            Invalid chars: {{ invalidChars }}
                                        </div>
                                    </div>

                                    <div class="field">
                                        <label><span>* </span>Verify Email</label>
                                        <input type="email" formControlName="verifyEmail" maxlength="100"
                                            pattern="^[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]@[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$" />
                                        <div class="error-message"
                                            *ngIf="step3Group | invalidChars:'verifyEmail':ValidationPatterns.ALLOWED_EMAIL_CHARS as invalidChars">
                                            Invalid chars: {{ invalidChars }}
                                        </div>
                                    </div>
                                </div>

                                <div class="row address-row">
                                    <div class="field">
                                        <label><span>* </span>Address</label>
                                    
                                        <app-google-place-autocomplete [formGroup]="step3Group" address1ControlName="address1" cityControlName="city"
                                            stateControlName="state" zipCodeControlName="zip" [maxlength]="60">
                                        </app-google-place-autocomplete>
                                    
                                        <div class="error-message"
                                            *ngIf="step3Group | invalidChars:'address1':ValidationPatterns.ALLOWED_ADDRESS_CHARS as invalidChars">
                                            Invalid chars: {{ invalidChars }}
                                        </div>
                                    </div>

                                    <div class="field">
                                        <label>Address 2</label>
                                        <input formControlName="address2" maxlength="60" />
                                        <div class="error-message"
                                            *ngIf="step3Group | invalidChars:'address2':ValidationPatterns.ALLOWED_ADDRESS_CHARS as invalidChars">
                                            Invalid chars: {{ invalidChars }}
                                        </div>
                                    </div>

                                    <div class="field">
                                        <label><span>* </span>City</label>
                                        <input formControlName="city" maxlength="30" />
                                        <div class="error-message"
                                            *ngIf="step3Group | invalidChars:'city':ValidationPatterns.ALLOWED_CITY_CHARS as invalidChars">
                                            Invalid chars: {{ invalidChars }}
                                        </div>
                                    </div>

                                    <div class="field" [ngClass]="displayFieldCss('step3.state')">
                                        <label><span>* </span>State</label>
                                        <select formControlName="state" id="state">
                                            <option value="">Select</option>
                                            <option *ngFor="let state of stateList" [value]="state.stateCode">
                                                {{ state.stateName }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="field">
                                        <label><span>* </span>Zip Code</label>
                                        <input type="tel" formControlName="zip" minlength="5" maxlength="10"
                                            inputmode="numeric" placeholder="XXXXX-XXXX" mask="00000-9999"
                                            [validation]="true" [dropSpecialCharacters]="true">
                                    </div>
                                </div>
                            </div>

                            <!-- ================= LEGAL SECTION ================= -->
                            <h3 class="step-subtitle">Legal Notice Address</h3>

                            <div>

                                <div class="required-note">
                                    <input type="checkbox" formControlName="legalSameAsBusiness"
                                        (change)="toggleLegalAddressSync()" />
                                    The legal notice address is the same as the business/organization account
                                    information
                                </div>

                                <div class="row business-row">
                                    <div class="field">
                                        <label><span>* </span>First Name</label>
                                        <input formControlName="legalFirstName" maxlength="100" />
                                        <div class="error-message"
                                            *ngIf="step3Group | invalidChars:'legalFirstName':ValidationPatterns.ALLOWED_NAME_CHARS as invalidChars">
                                            Invalid chars: {{ invalidChars }}
                                        </div>
                                    </div>

                                    <div class="field">
                                        <label><span>* </span>Last Name</label>
                                        <input formControlName="legalLastName" maxlength="100" />
                                        <div class="error-message"
                                            *ngIf="step3Group | invalidChars:'legalLastName':ValidationPatterns.ALLOWED_NAME_CHARS as invalidChars">
                                            Invalid chars: {{ invalidChars }}
                                        </div>
                                    </div>
                                </div>

                                <div class="row address-row">
                                    <div class="field">
                                        <label><span>* </span>Address</label>
                                    
                                        <app-google-place-autocomplete [formGroup]="step3Group" address1ControlName="legalAddress1"
                                            cityControlName="legalCity" stateControlName="legalState" zipCodeControlName="legalZip" [maxlength]="60">
                                        </app-google-place-autocomplete>
                                    
                                        <div class="error-message"
                                            *ngIf="step3Group | invalidChars:'legalAddress1':ValidationPatterns.ALLOWED_ADDRESS_CHARS as invalidChars">
                                            Invalid chars: {{ invalidChars }}
                                        </div>
                                    </div>

                                    <div class="field">
                                        <label>Address 2</label>
                                        <input formControlName="legalAddress2" maxlength="60" />
                                        <div class="error-message"
                                            *ngIf="step3Group | invalidChars:'legalAddress2':ValidationPatterns.ALLOWED_ADDRESS_CHARS as invalidChars">
                                            Invalid chars: {{ invalidChars }}
                                        </div>
                                    </div>

                                    <div class="field">
                                        <label><span>* </span>City</label>
                                        <input formControlName="legalCity" maxlength="30" />
                                        <div class="error-message"
                                            *ngIf="step3Group | invalidChars:'legalCity':ValidationPatterns.ALLOWED_CITY_CHARS as invalidChars">
                                            Invalid chars: {{ invalidChars }}
                                        </div>
                                    </div>

                                    <div class="field" [ngClass]="displayFieldCss('step3.legalState')">
                                        <label><span>* </span>State</label>
                                        <select formControlName="legalState" id="legalState">
                                            <option value="">Select</option>
                                            <option *ngFor="let state of stateList" [value]="state.stateCode">
                                                {{ state.stateName }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="field">
                                        <label><span>* </span>Zip Code</label>
                                        <input type="tel" formControlName="legalZip" minlength="5" maxlength="10"
                                            inputmode="numeric" placeholder="XXXXX-XXXX" mask="00000-9999"
                                            [validation]="true" [dropSpecialCharacters]="true">
                                    </div>
                                </div>
                            </div>

                            <!-- REQUIRED NOTE -->
                            <div class="required-note">
                                <span>* </span> Required
                            </div>

                        </div>

                        <div class="form-actions">
                            <button type="button" (click)="previousStep(3)" pStepperPrev>Back</button>
                            <button type="button" (click)="cancel()">Cancel</button>
                            <button type="button" (click)="nextStep('step3', 3)" pStepperNext>Next</button>
                        </div>
                    </form>
                </ng-template>
            </p-step-panel>

            <p-step-panel [value]="4">
                <ng-template pTemplate="content">
                    <h2 class="step-title">Voucher Agreement</h2>
                    <form [formGroup]="step4Group">
                        <div class="step-note">
                            Please review and electronically sign the agreement below.
                        </div>
                        <div class="agreement-box">
                            <div class="text-right" id="walgreenLogo">
                                <div>
                                    <img src="../assets/walgreens_email_logo.png" class="img-fluid" />
                                </div>
                            </div>
                            <div class="text-center col-md-8 col-12 mx-auto">
                                <h5>{{languageVariables.pageTitle}}</h5>
                                <!-- <h3 *ngIf="languageVariables.pageTitle==''" class="text-center mb-5"
                     style="color:#212529">IMMUNIZATION SERVICE AGREEMENT</h3> -->
                                <h3 *ngIf="languageVariables.pageTitle==''&&isCovidVaccineAvailable!=true"
                                    class="text-center mb-5" style="color:#212529">IMMUNIZATION SERVICE AGREEMENT</h3>
                                <h3 *ngIf="languageVariables.pageTitle==''&&isCovidVaccineAvailable==true"
                                    class="text-center mb-5" style="color:#212529">COVID-19 IMMUNIZATION SERVICE
                                    AGREEMENT</h3>
                                <h3 *ngIf="isCovidVaccineAvailable==true" class="text-center mb-5 "
                                    style="color:#212529">PRIVATE CLINIC and/or VOUCHERS</h3>
                            </div>

                            <ng-container>
                                <div>
                                    <p class="black-font"><span style="text-align: justify;"
                                            [innerHTML]="englishLanguage"></span></p>
                                    <p class="black-font"><span style="text-align: justify;"
                                            [innerHTML]="enheader"></span></p>
                                </div>
                            </ng-container>

                            <div style="text-align: center;">
                                <p><b>IN WITNESS WHEREOF</b>, Client and Walgreens have executed this Agreement.</p>
                            </div>
                            <div>

                                <div class="agreement-two-column">

    <div class="agreement-column">
                                        <p><b>CLIENT: {{ step3Group.value.businessName }}</b></p>
                                        <p>SIGNATURE:&nbsp; <span
                                                style="font-family: 'La Belle Aurore', cursive !important;font-size: 24px !important;">{{
                                                step4Group.value.signatureName }}</span></p>
                                        <p>NAME: {{ step4Group.value.signatureName }}</p>
                                        <p>TITLE: {{ step4Group.value.signatureJobTitle }}</p>
                                        <p>DATE: {{ today | date:'MM/dd/yyyy' }}</p>
                                        <p><u>Legal Notice Address</u>:<br>
                                            {{ step3Group.value.businessName }}<br>                                            
                                            {{ step3Group.value.legalAddress1 + (step3Group.value.legalAddress2 ? ' ' + step3Group.value.legalAddress2 : '') }}<br>
                                            {{ step3Group.value.legalCity }}, {{ step3Group.value.legalState }} {{
                                            step3Group.value.legalZip }}<br>
                                            Attn: {{ step3Group.value.legalFirstName + ' ' +
                                            step3Group.value.legalLastName }}
                                        </p>
                                    </div>
                                    <div class="agreement-column">
                                        <p><b>WALGREEN CO.</b></p>
                                        <p>SIGNATURE:&nbsp; <span
                                                style="font-family: 'La Belle Aurore', cursive !important;font-size: 24px !important;"></span></p>
                                        <p>NAME: </p>
                                        <p>TITLE: </p>
                                        <p>DATE: </p>
                                        <p><u>Legal Notice Address</u>:<br>
                                            Walgreen Co<br>
                                            104 Wilmot Road, MS 1446<br>
                                            Deerfield, IL 60015<br>
                                            Attn: Managed Markets Legal (retail flu/immunize)<br><br>
                                            AND SEND VIA EMAIL TO:<br>
                                            HealthLawLegalNotices&#64;walgreens.com
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h3 class="text-center">ATTACHMENT A</h3>
                                <h3 class="text-center">ARTICLE I</h3>
                                <p style="text-align: justify;">1.1 In accordance with the Agreement, for each 
                                    Immunization administered by Walgreens under this Agreement, Walgreens will be 
                                    entitled to the applicable reimbursement rates set forth in Table 1, plus any 
                                    government-imposed taxes and/or tariffs, on such products or services, however 
                                    styled, using the payment billing method agreed to by the Parties indicated below. 
                                    In the event that the U.S. Food and Drug Administration (‘FDA’) approves an 
                                    Immunization or issues an Emergency Use Authorization for an Immunization after the 
                                    Effective Date and such Immunization is (i) available for purchase by Walgreens, or 
                                    (ii) is made available to Walgreens to administer but not purchase, Walgreens has 
                                    the right to notify Client of a new reimbursement rate or fee, or both, for such 
                                    Immunization, which will be effective ten (10) days following Client’s receipt of the 
                                    notice. In the event Client notifies Walgreens in writing that it objects to the new 
                                    reimbursement rate or fee, or both, within the ten (10) day period, Walgreens may 
                                    elect, in its sole discretion, to not administer the Immunization to Participants. 
                                    Client acknowledges that the fees and reimbursement rates set forth in the Agreement 
                                    are Walgreens’ Confidential Information and Client agrees not to disclose this
                                    information to any third-party other than as minimally necessary under the terms of
                                    this Agreement. Unless otherwise indicated below, the rates listed in Table 1 are
                                    inclusive of the cost of vaccine, dispensing fee, and administration fee.</p>
                            </div>

                            <div>
                                <h3 class="text-center">TABLE 1</h3>
                                <table style="width: 100%;" class="mb-5">
                                    <thead style="background-color: #2d2525; color: #ffffff;">
                                        <tr>
                                            <th style="padding: 12px 16px;text-align: left;">Vaccine</th>
                                            <th style="padding: 12px 16px;text-align: right;">Reimbursement Rate (per
                                                dose)</th>
                                        </tr>
                                    </thead>
                                    <tbody style="border-bottom: 1px solid #ddd;">
                                        <tr *ngFor="let vaccine of step1Group.value.vaccines">
                                            <td style="padding: 12px 16px;text-align: left;">{{vaccine.vaccineName + ' '
                                                + vaccine.vaccineNameShort }}</td>
                                            <td style="padding: 12px 16px;text-align: right;">${{ vaccine.vaccinePrice |
                                                number:'1.2-2' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div>
                                <h3 class="text-center">ATTACHMENT B</h3>
                                <h3 class="text-center">TERMS AND CONDITIONS</h3>
                                <div class="agreement-two-column">

    <div class="agreement-column terms-column" style="text-align: justify;">
                                        <strong>I. WALGREENS&rsquo; RESPONSIBILITIES </strong><br><br>
                                        1.1 <u>Immunizations</u>. Subject to limitations or restrictions imposed by federal
                                        and state contracts, laws, and regulations, and the availability of appropriate
                                        Immunizations, Walgreens will administer Immunizations to Participants either
                                        directly or through an authorized provider. The Parties agree to comply with all
                                        procedures set forth in this Agreement. When required by state law, Walgreens
                                        will require Participants to provide a valid prescription from their physician
                                        or allow the health care professional to contact their physician to obtain a
                                        valid prescription; however, for certain specific Immunizations, Walgreens may
                                        be responsible for obtaining standing orders from physicians. Participants will
                                        be required to complete a Walgreens vaccine administration record and consent
                                        form before receiving an Immunization.<br><br>
                                        1.2 <u>Professional Judgment</u>. Walgreens may withhold administration of 
                                        Immunizations to a Participant for good
                                        cause, including but not limited to, Client&rsquo;s or Participant&rsquo;s
                                        (where applicable) failure to pay for Immunization, requests by Participant for
                                        services inconsistent with applicable legal requirements; or where, in the
                                        professional judgment of the health care professional, the services should not
                                        be rendered.
                                        <h4>II. CLIENT&rsquo;S RESPONSIBILITIES</h4>
                                        2.1 <u>Vouchers</u>. If the Parties agree in writing that Walgreens will administer Immunizations
                                        upon receipt of a Walgreens approved voucher issued to Participants by Client
                                        (&ldquo;<b>Vouchers</b>&rdquo;), Client will provide each Participant with a
                                        Voucher, and the Participant may redeem the Voucher at a participating Walgreens
                                        retail store location. Once the Voucher is approved by both Parties it may not
                                        be modified. Client may not rescind, retract, reduce or deny payment owed to
                                        Walgreens for claims where Immunizations were provided to its Participants, even
                                        if Client no longer considers the individual presenting the Voucher to be a
                                        Participant.
                                        <h4>III. PAYMENT AND BILLING </h4>
                                        3.1 <u>Payment</u>. Walgreens will invoice Client for Immunizations administered to
                                        Participants (including any applicable fees as listed in Attachment A) and
                                        Client will pay all invoices in full within thirty (30) days from receipt.
                                        Payments will be made to the remittance address set forth on the invoice.
                                        However, in the event the Parties agree in writing, solely for those amounts
                                        listed in Article I of Attachment A, and (i) Participant provides evidence of
                                        coverage under thirdparty insurance or a government funded program (e.g.,
                                        Medicare) (&ldquo;<b>Third Party Payor</b>&rdquo;) prior to the provision of
                                        Immunizations; and (ii) Walgreens is contracted with that Third Party Payor,
                                        Walgreens, will, except as otherwise stated herein, submit the claim for
                                        Immunizations to the Participant&rsquo;s Third Party Payor, and any copayment,
                                        coinsurance, deductible owed by the Participant will be collected at the time of
                                        service or billed at a later date. If evidence of coverage by a Third Party
                                        Payor is not provided by a Participant at the time of service or a claim for
                                        reimbursement is denied by a Third Party Payor, Client will reimburse Walgreens
                                        for all Immunizations administered to the Participant. For the avoidance of doubt, 
                                        any internal Client requirements and/or policies, not otherwise set forth herein, 
                                        regarding the Immunizations provided hereunder shall not alter or impact Client’s 
                                        obligation to pay for amounts owed Walgreens under this Agreement.<br><br> 
                                        3.2 <u>Late Payment</u>. All sums owed by Client to Walgreens will bear interest of 1.5%
                                        per month from the date payment is due until paid; however, in no event will
                                        such interest rate be greater than the rate permitted by law. Client shall be
                                        solely responsible for any and all costs incurred by Walgreens in seeking
                                        collection of any delinquent amounts owed by Client. Walgreens may invoice
                                        Client for interest and costs due under this Section on a monthly basis and
                                        payment will be due within thirty (30) days from receipt.<br><br> 
                                        3.3 <u>Change Event Notification</u>. In the event of a Change Event (as defined below) 
                                        Walgreens will provide written notice to Client with the applicable Change Event rate 
                                        changes (&ldquo;<b>Update Notification</b>&rdquo;).   The adjusted rates contained in the Update Notification 
                                        will be effective ten (10) days following Client’s receipt of the rates unless Client 
                                        notifies Walgreens that it does not agree to the adjusted rates within the ten (10) day 
                                        period, in which case Walgreens may discontinue providing Immunization services. Client's 
                                        failure to notify Walgreens of its objection to the Update Notification within the timeframe 
                                        set forth above, shall be deemed Client's acceptance of the Update Notification, which shall 
                                        be added to and made part of the Agreement as set forth in such Update Notification.<br><br>
                                        3.4 <u>Change Event (defined)</u>. For purposes of
                                        this Agreement, &ldquo;<b>Change Event</b>&rdquo; means an event when: (i) the pricing
                                        source: (a) changes the methodology, factors or algorithms, by which Walgreens
                                        relied upon to determine the reimbursement rates listed herein, used by the
                                        pricing source (&ldquo;<b>Benchmark</b>&rdquo;) is calculated or reported, (b) substitutes 
                                        for the Benchmark with any other pricing benchmark or metric available in the market place, 
                                        (c) ceases to publish the Benchmark; or (d) makes any other change that would impact the relative 
                                        economic position of the parties; (ii) there is any change to Walgreens procurement or operations 
                                        that materially impacts the current economics of Walgreens under this Agreement or; (iii) changes 
                                        to federal, state or local laws, ordinances, regulations or guidance that may impact the delivery, 
                                        rates, or administration of the Immunizations identified in this Agreement.
                                        <h4>IV. TERM AND TERMINATION</h4>4.1
                                        <u>Term and Termination</u>. This Agreement will become effective on the
                                        Effective Date and shall continue in full force and effect for an initial term
                                        of one (1) year. Either Party may terminate this Agreement at any time
                                        without cause by giving at least thirty (30) days&rsquo; prior written notice to
                                        the other Party.<br><br>
                                        4.2 <u>Effect of Termination</u>. Termination will have no effect upon the rights or obligations 
                                        of the Parties arising out of any transactions occurring prior to the effective date of such 
                                        termination.<br><br>
                                        4.3 <u>Waiver</u>. The waiver by either Party of a breach or violation of any
                                        provision of this Agreement shall not operate as or be construed to be a waiver
                                        of any subsequent breach or violation thereof.
                                        <h4>V. INSURANCE AND INDEMNIFICATION</h4>
                                        5.1 <u>Insurance</u>. Each Party will self-insure or maintain at its sole 
                                        expense, and in amounts consistent with industry standards,
                                        insurance for general and professional liability and such other 
                                        insurance as may be necessary to insure the Party, its 
                                        employees, and agents against any claim or claims for damages 
                                        arising out of or in connection with its duties and obligations 
                                        under this Agreement. Upon request from Walgreens, Client will
                                        provide a memorandum of insurance or certificate of insurance. 
                                        Walgreens&rsquo; insurance information is available at 
                                        www.walgreens.com/insurance.<br><br>
                                        5.2 <u>Indemnification</u>. To the extent permitted by law, each Party 
                                        will indemnify, defend, and hold harmless the other Party, 
                                        including its employees and agents, from and against any and all 
                                        third-party claims or liabilities arising from the negligence or
                                    </div>
                                     <div class="agreement-column terms-column" style="text-align: justify;">
                                        willful misconduct of the indemnifying Party, its
                                        employees, or agents in carrying out its duties, obligations, representations,
                                        warranties and covenants under the terms of this Agreement. EXCEPT FOR ANY
                                        EXPRESS WARRANTIES SET FORTH IN THIS AGREEMENT, THE PARTIES HEREBY DISCLAIM ANY
                                        IMPLIED WARRANTIES OF ANY KIND, INCLUDING WARRANTY OF MERCHANTABILITY, AND
                                        FITNESS FOR A PARTICULAR PURPOSE. In no event shall either Party be liable to
                                        the other Party for any indirect, special, or consequential damages or lost
                                        profits, arising out of or related to performance of this Agreement or a breach
                                        of this Agreement, even if advised of the possibility of such damages or lost
                                        profits.. Notwithstanding the foregoing, the Parties agree that Walgreens is not
                                        liable for activities covered by the Public Readiness and Emergency Preparedness
                                        (PREP) Act, and the foregoing obligations of indemnity shall not apply to
                                        Walgreens for any claims or liabilities arising out of activities covered by the
                                        PREP Act or any other applicable laws related to vaccines and/or health care
                                        providers. This Section will survive the termination of this Agreement.
                                        <h4>VI. GENERAL TERMS</h4>
                                        6.1 <u>Business Confidentiality</u>. The Parties
                                        acknowledge that certain proprietary or confidential business information may be
                                        disclosed between the Parties (&ldquo;<b>Confidential Information</b>&rdquo;).
                                        Each Party will maintain the confidentiality of all Confidential Information,
                                        including, without limitation, implementing those precautions the Party employs
                                        with respect to its own Confidential Information and disclosing Confidential
                                        Information only to those employees who have a need to know in order to
                                        effectuate the purpose(s) of this Agreement or to maintain compliance with
                                        applicable laws. In no event will either Party use the other Party&rsquo;s
                                        Confidential Information to benefit itself or others, except as otherwise not
                                        prohibited under this Agreement. Confidential Information shall not include
                                        information: (i) generally known to the public or the industry without breach of
                                        this Agreement; (ii) independently developed by the receiving Party; (iii) known
                                        to or in the possession of the receiving Party prior to the disclosure pursuant
                                        to this Agreement; (iv) disclosed to the receiving Party by a third party
                                        without the confidentiality obligations set forth herein; or (v) required to be
                                        disclosed by any court or government agency; provided however, to the extent
                                        allowed by law, the receiving Party shall provide written notice of such planned
                                        disclosure to the disclosing Party allowing reasonable time for the disclosing
                                        Party to raise any objections to such disclosure. Each Party acknowledges that
                                        disclosure of the other Party&rsquo;s Confidential Information would cause the
                                        other Party irreparable harm and may, without limiting the remedies available
                                        for such breach, be enjoined at the instance of the harmed Party. This Section
                                        will survive the termination of this Agreement.<br><br>
                                        6.2 <u>Confidentiality of Protected Health Information</u>. The Parties agree to protect and
                                        respect each Participant&rsquo;s right to privacy and confidentiality concerning
                                        their medical and pharmaceutical records, and to protect all individually
                                        identifiable health information as protected health information from misuse or
                                        disclosure, in compliance with all applicable state and federal laws, including
                                        the Health Insurance Portability and Accountability Act of 1996. Without
                                        limiting the generality of the foregoing, the Parties agree to use
                                        Participant-specific information: (i) only for permitted treatment, billing and
                                        related record-keeping purposes; or (ii) as otherwise permitted by law. Failure
                                        by either Party to abide by these requirements shall be a basis for immediate
                                        termination of this Agreement. Nothing herein will limit either Party&rsquo;s
                                        use of any de-identified Participant information. This Section will survive the
                                        termination of this Agreement.
                                        <br><br>6.3 <u>Advertising</u>. Neither Party may advertise or use any 
                                        trademarks, service marks, or symbols of the other Party 
                                        without first receiving the written consent of the Party owning 
                                        the mark and/or symbol with the following exceptions:  Client 
                                        may use the name and the addresses of Walgreens locations in 
                                        materials to inform Participants that Walgreens provides Immunizations.  
                                        Any other reference to Walgreens in any Client materials must be 
                                        pre-approved, in writing, by Walgreens.<br><br>
                                        6.4 <u>Force Majeure</u>. The performance by either Party hereunder will
                                        be excused to the extent of circumstances beyond such Party&rsquo;s reasonable
                                        control, such as flood, tornado, earthquake, or other natural disaster,
                                        epidemic, pandemic, war, material destruction of facilities, fire, acts of
                                        terrorism, acts of God, etc. In such event, the Parties will use their best
                                        efforts to resume performance as soon as reasonably possible under the
                                        circumstances.<br><br>
                                        6.5 <u>Compliance</u>. Each Party agrees to comply with
                                        all applicable federal, state and local laws, rules, and regulations for each
                                        territory in which Immunizations are provided under this Agreement. Each Party
                                        will cooperate with reasonable requests by the other Party for information that
                                        is needed for its compliance with applicable laws, rules, and/or regulations.<br><br>
                                        6.6 <u>Assignment</u>. Neither Party may assign this Agreement to a
                                        third-party without the prior written consent of the other Party, except that
                                        either Party will have the right to assign this Agreement to any direct or
                                        indirect parent, subsidiary or affiliated company or to a successor company
                                        without such consent. Any permitted assignee will assume all obligations of its
                                        assignor under this Agreement. No assignment will relieve any Party of
                                        responsibility for the performance of any obligations which have already
                                        occurred. This Agreement will inure to the benefit of and be binding upon each
                                        Party, its respective successors and permitted assignees.<br><br>
                                        6.7 <u>Third Party Rights</u>. This Agreement is solely between Walgreens and Client and
                                        may not be construed to create any rights or remedies in favor of any third
                                        party, including, but not limited to, any Participant.<br><br>
                                        6.8
                                        <u>Notices</u>. All notices provided for herein must be in writing, sent by U.S.
                                        certified mail, return receipt requested, postage prepaid, or by overnight
                                        delivery service providing proof of receipt to the address set forth following
                                        the signature blocks. Notices will be deemed delivered upon receipt or upon
                                        refusal to accept delivery.<br><br>
                                        6.9 <u>Entire Agreement</u>. This Agreement,
                                        which includes any and all attachments, exhibits, riders, and other documents
                                        referenced herein, constitutes the entire and full agreement between the Parties
                                        relating to the subject matter herein and supersedes any previous contract, and
                                        except as otherwise permitted hereunder, no changes, amendments, or alterations
                                        will be effective unless reduced to a writing signed by a representative of each
                                        Party. Any prior agreements, documents, understandings, or representations
                                        relating to the subject matter of this Agreement not expressly set forth herein
                                        or referred to or incorporated herein by reference are of no force or effect.<br><br>
                                        6.10 <u>Counterparts</u>. This Agreement may be executed in two or more
                                        counterparts, each of which together shall be deemed an original, and all of
                                        which together shall constitute one and the same instrument. Execution and
                                        delivery of this Agreement may be completed electronically through facsimile,
                                        digitally or by .pdf file and any such electronic signature contained therein,
                                        shall create a valid and binding obligation of the Party executing it, having
                                        the same effect as if the original handwritten signature had been signed and
                                        delivered to the other Party.
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h3 class="text-center">[END OF ATTACHMENT B]</h3>
                                <div style="display:flex;">
                                    <div style="width:100%;">
                                        <p style="text-align: left;">Immunization Service Agreement Template TribDir - 04062026 (NAR) Walgreen Co. All rights reserved.</p>
                                    </div>
                                </div>
                            </div>


                        </div>


                        <div class="border-box">
                            <div class="consent-note">
                                <input type="checkbox" formControlName="consent" />
                                I consent to the use of electronic signatures and electronic records and confirm that my
                                electronic signature on this contract is legally binding.
                            </div>

                            <div class="form-grid">
                                <div class="field">
                                    <label><span>* </span>Signature (First & Last Name)</label>
                                    <input formControlName="signatureName" type="text" class="signature"
                                        maxlength="100" />
                                    <div class="error-message"
                                        *ngIf="step4Group | invalidChars:'signatureName':ValidationPatterns.ALLOWED_NAME_CHARS as invalidChars">
                                        Invalid chars: {{ invalidChars }}
                                    </div>
                                </div>

                                <div class="field">
                                    <label><span>* </span>Job Title</label>
                                    <input formControlName="signatureJobTitle" type="text" maxlength="100" />
                                    <div class="error-message"
                                        *ngIf="step4Group | invalidChars:'signatureJobTitle':ValidationPatterns.ALLOWED_JOB_CHARS as invalidChars">
                                        Invalid chars: {{ invalidChars }}
                                    </div>
                                </div>

                                <div class="field">
                                    <label><span>* </span>Date</label>
                                    <p-datepicker formControlName="signatureDate" styleClass="w-full"></p-datepicker>
                                </div>
                            </div>

                        </div>
                        <div class="form-actions">
                            <button type="button" (click)="previousStep(4)" pStepperPrev>Back</button>
                            <button type="button" (click)="cancel()">Cancel</button>

                            <!-- Show Next when W9 is NOT uploaded -->
                            <button *ngIf="!isW9Uploaded" type="button" (click)="nextStep('step4', 4)" pStepperNext>
                                Next
                            </button>

                            <!-- Show Submit when W9 is already uploaded -->
                            <button *ngIf="isW9Uploaded" type="button" (click)="submitVoucher()">
                                Submit
                            </button>
                        </div>
                    </form>
                </ng-template>
            </p-step-panel>

            <!-- <p-step-panel *ngIf="!isW9Uploaded" [value]="6">
                <ng-template pTemplate="content">
                    <h2 class="step-title">Business Verification</h2>
                    <form [formGroup]="step5Group">
                        <div>
                            <div class="step-note">
                                To complete your initial voucher request, please upload an IRS Form W-9 to verify your
                                business or organization.
                            </div>
                            <div class="border-box">
                                <div class="required-note">
                                    By uploading a current and completed IRS Form W-9 (“W-9ˮ), the submitting business,
                                    organization, or individual certifies that the information provided
                                    is true, correct, and complete, and that they are authorized to act on behalf of the
                                    entity identified on the form. Submission of a W-9 serves as
                                    verification of the submitterʼs association with, and authority to represent, the
                                    named
                                    business or organization.
                                </div>
                                <div class="required-note">
                                    Knowingly providing false, fictitious, or fraudulent information on a W-9 is a
                                    violation
                                    of U.S. federal law. Falsifying or misrepresenting taxpayer
                                    identification information may subject the individual or entity to civil penalties,
                                    criminal penalties, or both, including fines and potential prosecution
                                    under applicable federal statutes.
                                </div>
                                <div class="required-note">
                                    By submitting a W-9, the submitter acknowledges these responsibilities and legal
                                    obligations.
                                </div>
                                <div class="row">

                                    <div class="field col-12 md:col-6">
                                        <label><span>* </span>Accepted file types: pdf or jpg</label>
                                        <div class="upload-container">
                                            <button type="button" class="upload-btn" (click)="triggerFileSelect()">
                                                Browse for File
                                            </button>
                                        </div>

                                        <p-fileUpload #fileUploadRef mode="advanced" name="file" [multiple]="false"
                                            [auto]="false" accept=".pdf,.jpg,.jpeg" maxFileSize="2000000"
                                            [customUpload]="true" (onSelect)="onFileSelect($event)"
                                            (onRemove)="onFileRemove($event)" [showUploadButton]="false"
                                            [showCancelButton]="false">
                                            <ng-template pTemplate="header"></ng-template>
                                        </p-fileUpload>

                                        <small class="p-error"
                                            *ngIf="step5Group.get('w9File')?.invalid && step5Group.get('w9File')?.touched">
                                            File is required
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-actions">
                            <button type="button" (click)="previousStep(5)" pStepperPrev>Back</button>
                            <button type="button" (click)="cancel()">Cancel</button>
                            <button type="button" (click)="submitVoucher()" pStepperNext>Submit</button>
                        </div>
                    </form>
                </ng-template>
            </p-step-panel> -->

            <p-step-panel [value]="5">
                <ng-template pTemplate="content">
                    <h2 class="step-title">{{ step5Title }}</h2>
                    <div>
                        <section class="thanks">
                            <div class="thanks-grid">
                                <div class="pr-20">
                                    <h2 class="business-title">Thanks for completing your setup!</h2>
                                    <!-- <div *ngIf="!w9Approved" class="download-note">Your account is now under review.
                                        This verification step helps ensure everything is set up correctly and typically
                                        takes up to <strong>five business days.</strong>
                                    </div>
                                    <div *ngIf="!w9Approved" class="download-note">
                                        Once your account is approved, we'll send you an email with a link to return to
                                        the portal and download your <strong>ready to use immunization
                                            vouchers.</strong>
                                    </div> -->
                                    <div *ngIf="w9Approved" class="download-note">
                                        You may download your <strong>ready to use immunization vouchers</strong>
                                        immediately from the Vouchers list on this page, access them later from the
                                        account Vouchers & Agreements page, or from the link sent to your email.
                                    </div>
                                    <div *ngIf="w9Approved" class="download-note">
                                        Once downloaded, you may distribute the vouchers to your employees or members.
                                        Each voucher contains a unique code linked to your organizationʼs account.
                                        Walgreens will issue a monthly invoice for all vouchers redeemed at any
                                        Walgreens location.
                                    </div>
                                    <!-- <div *ngIf="!w9Approved" class="error-note">
                                        <strong>Verification in progress –– vouchers will be available within 5 business
                                            days</strong>
                                    </div> -->
                                    <div class="done-div">
                                        <button *ngIf="w9Approved" type="button" class="button-primary"
                                            (click)="downloadFile(agreementFile.originalFileName)">
                                            Download Agreement
                                        </button>

                                        <button type="button" class="button-primary" (click)="doneClicked()">
                                            Done
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    <!-- <div *ngIf="!w9Approved" class="thanks-image">
                                        <img src="assets/15082025_Respiratory_flu.jpg" class="w-full">
                                    </div> -->
                                    <div *ngIf="w9Approved" class="voucher-card">
                                        <div class="voucher-header">
                                            Vouchers
                                        </div>

                                        <p-table [value]="vouchersList" styleClass="voucher-table">

                                            <ng-template pTemplate="body" let-file>
                                                <tr>
                                                    <td>
                                                        <button class="text-btn"
                                                            (click)="downloadFile(file.originalFileName)">
                                                            {{ file.originalFileName }}
                                                        </button>
                                                    </td>
                                                </tr>
                                            </ng-template>
                                        </p-table>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="complete">
                            <h2>What happens next?</h2>
                            <!-- <ul *ngIf="!w9Approved" class="what-list">
                                <li>
                                    <strong>1. We verify your documentation</strong><br>
                                    We review your business details and W-9 to confirm everything is complete.
                                </li>
                                <li>
                                    <strong>2. Vouchers are genrated</strong><br>
                                    Your immunization vouchers are created and added to your portal.
                                </li>
                                <li>
                                    <strong>3. You receive an email with a direct link</strong><br>
                                    Weʼll notify you when your vouchers are ready to download.
                                </li>
                            </ul> -->
                            <ul *ngIf="w9Approved" class="what-list">
                                <li>
                                    <strong>1. Download your ready to use immunization vouchers</strong><br>
                                    Simply click the pdf liinks above to download your vouchers
                                </li>
                                <li>
                                    <strong>2. Distribute the vouchers</strong><br>
                                    Share the downloaded vouchers with your employees or participants
                                </li>
                                <li>
                                    <strong>3. Find your closest Walgreens location</strong><br>
                                    Visit <a href="https://www.walgreens.com/storelocator"
                                        target="_blank">https://www.walgreens.com/storelocator</a> to find your closest
                                    Walgreens or Duane Reade pharmacy
                                </li>
                            </ul>

                        </section>
                        <section class="partner">
                            <h2>Thanks for partnering with Walgreens</h2>
                            <div class="partner-grid">
                                <div class="card">
                                    <div class="card-header">
                                        <img src="assets/store.png" alt="">
                                        <h3>Nationwide Convenience</h3>
                                    </div>
                                    <p>
                                        With one of the largest pharmacy networks in the country. Walgreens makes it
                                        simple for your employees whether theyʼre close to home or the workplace.
                                    </p>
                                </div>
                                <div class="card">
                                    <div class="card-header">
                                        <img src="assets/pharmacist_icon.png" alt="">
                                        <h3>Trusted Pharmacist Expertise</h3>
                                    </div>
                                    <p>
                                        Our licensed pharmacists provide compassionate, knowledgable care and follow the
                                        latest clinical guidance to help safeguard your workforceʼs health.
                                    </p>
                                </div>
                                <div class="card">
                                    <div class="card-header">
                                        <img src="assets/seasonal_vaccines_icon.png" alt="">
                                        <h3>Fast, Modern Scheduling</h3>
                                    </div>
                                    <p>
                                        Employees can schedule online, through the Walgreens app, or walk into most
                                        locations to get vaccinated when it fits their day.
                                    </p>
                                </div>
                            </div>
                            <div class="partner-grid2">
                                <div></div>
                                <div class="card">
                                    <div class="card-header">
                                        <img src="assets/w_bandage.png" alt="">
                                        <h3>A Streamlined Experience</h3>
                                    </div>
                                    <p>
                                        From digital forms to automatic appointment reminders, weʼve designed the
                                        process to be smooth and stress free so your team can stay focused on what
                                        matters.
                                    </p>
                                </div>
                                <div class="card">
                                    <div class="card-header">
                                        <img src="assets/immunization.png" alt="">
                                        <h3>Comprehensive Vaccine Options</h3>
                                    </div>
                                    <p>
                                        We offer a wide range of CDC recommended vaccines to support seasonal, required,
                                        and preventitive immunization needs for your organization.
                                    </p>
                                </div>
                                <div></div>
                            </div>
                        </section>
                        <section class="wait">
                            <div class="wait-grid">
                                <div class="thanks-image">
                                    <img src="assets/routine_immunization.jpg" class="w-full">
                                </div>
                                <div>
                                    <h2>{{ w9Approved ? 'Want to know more?' : 'While you wait' }}</h2>
                                    <div class="download-note">Additional resources to share are available on
                                        Walgreens blog</div>
                                    <div><strong>The Thread:</strong></div>
                                    <div>
                                        <ul class="what-list">
                                            <li><a href="https://blog.walgreens.com/health/covid-19.html"
                                                    target="_blank">All COVID-19 information from vaccines, symptoms, testing options
                                                and more</a></li>
                                            <li><a href="https://blog.walgreens.com/health/vaccines-immunizations.html"
                                                    target="_blank">All routine vaccines information including pneumococcal, shingles
                                                and others</a></li>
                                            <li>Schedule multiple vaccines in one appointment: <a
                                                    href="https://walgreens.com/findcare/schedule-vaccine"
                                                    target="_blank">https://walgreens.com/findcare/schedule-vaccine</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </ng-template>
            </p-step-panel>

        </p-step-panels>

    </p-stepper>
</div>
<p-dialog header="{{ dialogSummary }}" [(visible)]="modalDlg" [closable]="false" [closeOnEscape]="false"
    [modal]="true" [dismissableMask]="false" [style]="{ width: '40vw' }" [breakpoints]="{ '640px': '95vw' }">

    <div class="dialog-body" [innerHTML]="dialogMsg"></div>

    <ng-template pTemplate="footer">
        <div class="actions">
            <!-- Unsaved Changes -->
            <ng-container *ngIf="dialogType === 'unsaved'">
                <button type="button" class="button-secondary" (click)="stayOnPage()">
                    Continue Setup
                </button>

                <button type="button" class="button-primary" (click)="leavePage()">
                    Leave
                </button>
            </ng-container>

             <!-- business-verification -->
            <ng-container *ngIf="dialogType === 'business-verification'">

                <button type="button" class="button-secondary" (click)="okClicked()">
                    Cancel
                </button>

                <button type="button" class="button-primary" (click)="navigateToBusinessVerification()">
                    Start Business Verification
                </button>

            </ng-container>

            <!-- Normal Dialog -->
            <ng-container *ngIf="dialogType !== 'unsaved' && dialogType !== 'business-verification'">
                <button type="button" class="button-primary" (click)="okClicked()">
                    Ok
                </button>
            </ng-container>

        </div>
    </ng-template>
</p-dialog>